if (!customElements.get('custom-slider')) {
  customElements.define(
    'simple-tabs',
    class SimpleTabs extends HTMLElement {
      constructor() {
        super();
        this.tabsContainer = this.querySelector('.cf__tabs');
        this.tabContents = this.querySelectorAll('.cf__tab-content');
      }
      connectedCallback() {
        // Create buttons dynamically
        this.tabContents.forEach((content, index) => {
          const tabName = content.dataset.tabName || `Tab ${index + 1}`;
          const button = document.createElement('button');
          button.className = 'cf-tab';
          button.dataset.tab = index + 1;
          button.textContent = tabName;
          button.addEventListener('click', () => this.activateTab(index + 1));
          this.tabsContainer.appendChild(button);
        });
        // Activate first tab by default
        this.activateTab(1);
      }

      activateTab(tabIndex) {
        this.querySelectorAll('.cf__tab-content').forEach(content => {
          content.style.display = content.dataset.tab == tabIndex ? 'block' : 'none';
        });
        this.querySelectorAll('.cf-tab').forEach(button => {
          button.classList.toggle('active', button.dataset.tab == tabIndex);
        });
      }
    }
  )
}